import { AyaCourseApiDto, AyaCourseSummaryApiDto } from '@lx/shared/api';

export type AyaCourse = AyaCourseApiDto;
export type AyaCourseSummary = AyaCourseSummaryApiDto;
